module.exports = "{{download}}"